module.exports = "<h2>International Students: Application Form and Ordinance</h2>\r\n<ul style=\"list-style-type: none;\">\r\n\t<li><a href=\"http://www.mygbu.in/docs/ApplicationForm_InternationalStudents_27Feb13.pdf\" style=\"text-align: \">Application Form for Admission of International Students</a></li>\r\n\t<li><a href=\"http://www.mygbu.in/docs/InternationalAffairs_Ordinance_27Feb13.pdf\">Ordinance for Admission of International Students</a></li>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admissions/components/foreign-student/foreign-student.component.html
// module id = ./src/app/admissions/components/foreign-student/foreign-student.component.html
// module chunks = main